"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPrice = exports.convertLanguagePair = exports.convertDate = exports.valueOrDash = exports.keyLookupFromReadable = exports.readableList = exports.readableLookup = void 0;
const formatLocaleCode_1 = __importDefault(require("./formatLocaleCode"));
const formatNumber_1 = require("./formatNumber");
exports.readableLookup = (code, config, mapping) => {
    if (!code || !config || !config[mapping]) {
        return '-';
    }
    else if (config[mapping][code]) {
        return config[mapping][code];
    }
    else {
        return code;
    }
};
exports.readableList = (config, mapping) => {
    const list = [];
    if (config && config[mapping]) {
        for (const key in config[mapping]) {
            list.push(config[mapping][key]);
        }
    }
    return list;
};
exports.keyLookupFromReadable = (readable, config, mapping) => {
    if (readable && config && config[mapping]) {
        // @ts-ignore: TODO: Convert to for-of or array.forEach
        for (const key in config[mapping]) {
            if (config[mapping][key] === readable) {
                return key;
            }
        }
    }
    return readable;
};
exports.valueOrDash = value => value || '-';
exports.convertDate = date => (date && date.substring ? date.substring(0, 10) : '-');
exports.convertLanguagePair = (sourceLocale, targetLocale) => {
    try {
        return formatLocaleCode_1.default(sourceLocale) + ' ➡ ' + formatLocaleCode_1.default(targetLocale);
    }
    catch (_a) {
        return '-';
    }
};
exports.convertPrice = (price, currency) => price && price > 1e-10 ? formatNumber_1.formatCurrency(price, currency) : '-';
//# sourceMappingURL=ReadableConverter.js.map